import { render, staticRenderFns } from "./scroll-wagon.vue?vue&type=template&id=737628b0&"
import script from "./scroll-wagon.vue?vue&type=script&lang=ts&"
export * from "./scroll-wagon.vue?vue&type=script&lang=ts&"
import style0 from "./scroll-wagon.vue?vue&type=style&index=0&id=737628b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports